@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.ConfirmationDialog {
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 100px;
  min-width: 100px;
}
